import React from "react";
import { ScreenCloseModal } from "../../components/ScreenModal";
import QRCodeLogin from "../login/QRCodeLogin";
import { Str_AddAccount } from "../../language/string_res";
import * as ImSdk from "../../../imsdk/api";

const AddAccountScreen = ({ navigation, route }: any) => {
  return (
    <ScreenCloseModal title={Str_AddAccount}>
      <QRCodeLogin navigation={navigation} route={{ params: { isAddAccount: true,lastUid: ImSdk.getInstance().CurrentUid()} }} />
    </ScreenCloseModal>
  );
};

export default AddAccountScreen;
